// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ur3ur","inner":"Footer_inner__lNkQ9"};